// src/components/Icon/Icon.jsx
import React, { memo } from "react";

/**
 * Icon component
 *
 * Props:
 * - component: React component of the icon (e.g., from Phosphor)
 * - size: number, default 20
 * - color: string, default "currentColor"
 * - className: optional CSS class
 * - weight: optional icon weight (if supported)
 * - ...rest: other props passed to icon
 */
const Icon = ({
  component: IconComponent,
  size = 20,
  color = "currentColor",
  className,
  weight,
  ...rest
}) => {
  if (!IconComponent) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Icon component not provided");
    }
    return null;
  }

  return (
    <IconComponent
      size={size}
      color={color}
      className={className}
      weight={weight}
      {...rest}
    />
  );
};

// Memoized to prevent unnecessary re-renders when props don't change
export default memo(Icon);
